'use client';

import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  Box,
  BoxProps,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import Button from './Button';
import AppIsometric from './AppIsometric';
import { useResponsive } from '@/hooks/use-responsive';

const Root = styled(Box, {
  shouldForwardProp: (prop: PropertyKey) => ![''].includes(prop.toString()),
})<Partial<HelpChangeSectionCombinedProps>>(
  () => css`
    position: relative;
    z-index: 1;
    box-shadow: 0px 10px 15px 0px #00000033;
  `
);

export interface HelpChangeSectionProps {
  [prop: string]: any;
}

export type HelpChangeSectionCombinedProps = HelpChangeSectionProps & BoxProps;

const HelpChangeSection: React.FC<HelpChangeSectionCombinedProps> = (props) => {
  const { responsive } = useResponsive();

  return (
    <Root bg="dark.5" pt={150} {...props}>
      <Container size="xl">
        <Group
          wrap="nowrap"
          maw={responsive({
            xs: '100%',
            xl: '85%',
          })}
          style={{
            flexDirection: responsive({
              xs: 'column',
              lg: 'row',
            }),
            textAlign: responsive({
              xs: 'center',
              lg: 'left',
            }),
          }}
        >
          <Stack gap={5} flex={1}>
            <Text fw={500} style={{ color: 'var(--color-primary)' }}>
              Your Impact Matters
            </Text>

            <Title
              size={responsive({
                xs: 36,
                xl: 48,
              })}
              fw={700}
              c="white"
            >
              Help Change The Landscape
            </Title>

            <Button
              href="/contact"
              aria-label="Get Involved"
              variant="outline"
              color="white"
              hasArrow
              style={{
                alignSelf: responsive({
                  xs: 'center',
                  lg: 'flex-start',
                }),
                marginTop: 15,
              }}
            >
              Get Involved
            </Button>
          </Stack>

          <Text
            fz={16}
            fw={300}
            c="white"
            flex={1}
            style={responsive({
              xs: {
                marginTop: 10,
                marginBottom: 50,
              },
              lg: {
                padding: '10px 25px',
                marginTop: -30,
                marginLeft: 50,
                borderLeft: '1px solid var(--color-primary)',
              },
            })}
          >
            Together, we can customize solutions and enhance access to crucial
            information, making a lasting difference in the landscape of real
            estate.
          </Text>
        </Group>
      </Container>

      <AppIsometric mt={-90} />
    </Root>
  );
};

export default HelpChangeSection;